<div class="head-left-content">
    <ul class="navbar-nav">
        <li class="nav-item">
            <a (click)="onToggleMenuSidebar()" role="button"><img src="../../../../assets/img/menu-arrow.svg"
                    alt="menu arrow" /></a>
        </li>
    </ul>
    <div class="page-heading">
        <h2>{{title}}</h2>
    </div>
</div>
<ul class="navbar-nav ml-auto">
    <div class="avtar-info">
        <div class="dropdown">
            <a class="btn dropdown-toggle" type="button" id="dropdownMenuLink" data-bs-toggle="dropdown"
                aria-expanded="false">
                <h5 title="{{userName}}" class="wrapper" >Welcome, <strong class="paraWrap"> <span > {{userName}} </span></strong></h5>
                <img src="{{photo}}" alt="menu arrow" class="avtar" /><i class="fa-solid fa-angle-down ms-2"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li><a  (click)="goProfile()" title="Profile" class="dropdown-item "><i
                            class="fa-solid fa-user me-2"></i>{{commonConstantLabel.PROFILE}}</a></li>
                <li><a    (click)="goChangePassword()" title="Change Password" class="dropdown-item "><i
                            class="fa-solid fa-key me-2"></i>{{commonConstantLabel.CHANGE_PASSWORD}}</a></li>
                <li><a class="dropdown-item" title="Log Out" (click)="Logout()"> <i
                            class="fa-solid fa-right-from-bracket me-2"></i>{{commonConstantLabel.SIGN_OUT}}</a></li>
            </ul>
        </div>
    </div>
</ul>